import * as React from 'react';
import { Input, Button, Modal, notification } from 'antd';
import { FormItem } from '../../../../components/Form';

export interface IGeneralSettingsColProps {
  user: GQL.IUser;
  isNew: Boolean;
  onChange: Function;
  onChangePassword?: (pw: string) => Promise<boolean | undefined>;
}

interface IGeneralSettingsColState {
  changedPassword?: string;
  changedPasswordRetype?: string;
}

export default class GeneralSettingsCol extends React.Component<IGeneralSettingsColProps, IGeneralSettingsColState> {

  public render() {
    const { user, isNew } = this.props;

    return (
      <div>
        <FormItem label={'E-mail'} required={true}>
          <Input
            name={'email'}
            autoFocus={true}
            required={true}
            defaultValue={user.email || ''}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        {isNew &&
          <FormItem label={'Password'} required={true}>
            <Input
              name={'password'}
              type={'password'}
              required={true}
              onChange={e => this.props.onChange(e)}
            />
          </FormItem>}
        {!isNew && this.props.onChangePassword && <Button onClick={() => this.changePassword()}>Change password</Button>}
      </div>
    );
  }

  private arePasswordSame() {
    if (this.state && this.state.changedPassword && this.state.changedPasswordRetype && this.state.changedPassword === this.state.changedPasswordRetype) {
      return true;
    }
    return false;
  }

  private changePassword() {
    Modal.confirm({
      title: 'Change password',
      content: <>
        <Input
          name="changedPassword"
          type="password"
          required={true}
          onChange={(e) => this.setState({ changedPassword: e.target.value })}
          defaultValue={this.state && this.state.changedPassword}
        />
        <Input
          name="changedPasswordRetype"
          type="password"
          required={true}
          onChange={(e) => this.setState({ changedPasswordRetype: e.target.value })}
          defaultValue={this.state && this.state.changedPasswordRetype}
        />
      </>,
      onOk: () => {
        if (!this.arePasswordSame()) {
          Modal.error({
            title: 'Error changing password',
            content: 'Passwords are not same or are empty',
            onOk: () => this.changePassword(),
          });
          return;
        }
        if (this.props.onChangePassword && this.state.changedPassword) {
          this.props.onChangePassword(this.state.changedPassword)
            .then(res => {
              if (res) {
                notification.success({
                  message: 'Info',
                  description: `Password for ${this.props.user.email} changed`,
                });
                this.setState({ changedPassword: undefined, changedPasswordRetype: undefined });
              } else if (false === res) {
                notification.error({
                  message: 'Error',
                  description: `Error while changing password`,
                });
                this.changePassword();
              } else {
                notification.error({
                  message: 'Error',
                  description: `Unknown error while changing password`,
                });
                this.changePassword();
              }
            })
            .catch(e => {
              console.log(e);
            });
        }
      },
      onCancel: () => this.setState({ changedPassword: undefined, changedPasswordRetype: undefined }),
    });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Users/UserDetail/components/General.tsx